const getRoleAccessResponse = (response) => {
  const hostMenu = response?.menus
    ?.filter((item) => item.path === 'productivity-host')
    .map((menu) => {
      return {
        id: menu.id,
        permissions: menu.permissions.map((permission) => permission.id),
      };
    });

  const operatorMenu = response?.menus?.filter((item) => item.path !== 'productivity-host');

  return { hostMenu: hostMenu, operatorMenu: operatorMenu };
};

export default getRoleAccessResponse;
